import basePath from "base_path";
import ActionTypes from "../constants/action_types";

import createReduxPromiseAction from "utils/create_redux_promise_action";

export default function ragReportOrderReset(requestor) {
  return createReduxPromiseAction(
    ActionTypes.RAG_REPORT_ORDER_RESET,
    (organisationId, projectId, documentId, reportId, issuesetId) =>
      requestor
        .patch(
          `${basePath}/organisation/${organisationId}/project/${projectId}/document/${documentId}/reset`,
          {
            reportId,
            issuesetId,
          },
          {withCredentials: true},
        )
        .then(response => response.data),
  );
}
